<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑黑名单' : '新增黑名单'"
      :visible.sync="showAddOrEdit"
      width="500px"
      :before-close="cancelFun"
    >
      <el-form ref="form" :model="formData" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
                label="姓名"
                prop="memberName"
                :rules="[
                { required: true, message: '该项不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.memberName"
                  placeholder="请输入"
                  size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
                label="身份证号"
                prop="identityNo"
                :rules="[
                { required: true, message: '该项不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.identityNo"
                  placeholder="请输入"
                  size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
                label="手机号"
                prop="mobile"
                :rules="[
                { required: true, message: '该项不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.mobile"
                  placeholder="请输入"
                  size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="cancelFun">取 消</el-button>
        <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addRosterAPI, editRosterAPI, getRosterDetailAPI } from './api';

export default {
  name: 'BlackRosterAddOrEdit',
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        memberName: '',
        mobile: '',
        identityNo: '',
        riskLevel: 2,
        remark: '',
      }
    }
  },
  mounted() {
    if (this.rowId) this.getRosterDetail();
  },
  methods: {
    // 详情
    async getRosterDetail() {
      this.formData = await getRosterDetailAPI({ id: this.rowId });
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
    submitFun() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          (this.rowId ? editRosterAPI : addRosterAPI)(this.formData).then(
              () => {
                this.$message.success(this.rowId ? "编辑成功" : "新增成功");
                this.$emit("closeDialog", true);
              }
          );
        } else {
          return false;
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  .el-form {
    .el-form-item {
      .el-input {
        width: 350px;
      }
    }
  }
}
</style>
